module.exports = __webpack_public_path__ + "static/partnership-logo-e45f1ac7785faf8b5cf827eee58e7ab2.png";